import axios from 'axios';

const API_BASE_URL = 'http://148.72.245.102:8486'; // Change this if your backend URL is different
// const API_BASE_URL = 'http://192.168.0.214:8486'; // Change this if your backend URL is different

export const httpClient = axios.create({
  baseURL: API_BASE_URL,
});
